"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationsByCityLetter = void 0;
const getLocationsByCityLetter = (locations) => {
    let locationsByCityGroups = {};
    locations.forEach((location) => {
        const cityLetter = location.city.substr(0, 1).toUpperCase();
        if (!locationsByCityGroups[cityLetter]) {
            locationsByCityGroups[cityLetter] = {};
        }
        if (!locationsByCityGroups[cityLetter][location.city]) {
            locationsByCityGroups[cityLetter][location.city] = [];
        }
        locationsByCityGroups[cityLetter][location.city].push(location);
    });
    return locationsByCityGroups;
};
exports.getLocationsByCityLetter = getLocationsByCityLetter;
